import { useEffect, useState } from 'react';
import 'reactjs-popup/dist/index.css';
import { GrayButton } from '@shared/uikit/button';
import { TextInput } from '@shared/uikit/input-text';
import { ValidationError } from '@app/error/ValidationError';
import { ServerError } from '@app/error/ServerError';
import { Loader } from '@shared/uikit/loader';
import { Popup } from '@shared/uikit/popup';
import { X } from 'lucide-react';

interface Props {
  title: string;
  value?: string;
  open: boolean;
  onClose: VoidFunction;
  onSubmit: (hashrate: string) => void;
}

export const EditPopup = ({ value = '', title, open, onClose, onSubmit }: Props) => {
  const [hashrate, setHashrate] = useState<string>(value);
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [invalid, setInvalid] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    (async () => {
      if (open) return;

      onClear();
    })();
  }, [open]);

  const onClear = () => {
    setHashrate('');
  };

  return (
    <Popup open={open} width="340px" onClose={onClose}>
      <div className="pb-[15px] border-opacity-10 relative bg-[#19181B]">
        <input type="hidden" />
        <div className="flex items-center h-[24px]"></div>
        <div className="absolute right-0 top-0 cursor-pointer" onClick={onClose}>
          <X size={14} />
        </div>
      </div>

      <div className="flex flex-col w-full items-center gap-[20px] text-white mb-[40px]">
        <div className="w-full text-[18px]">
          <span>{title}</span>
        </div>
        <div className="w-[85%] relative">
          <TextInput
            width="100%"
            value={hashrate}
            borderColor="#373539"
            onChange={value => setHashrate(value)}
            placeholder=""
            decimalFormattingMode={true}
          />
          <span className="absolute top-1/2 -translate-y-1/2 right-[15px] text-[#959595] text-[12px] z-[5px]">
            {' '}
            Ph
          </span>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between text-left mt-[15px] gap-[20px]">
        <div className="text-[white] flex gap-[10px]">
          {!submitting && invalid && (error || !hashrate) ? (
            <div className="flex gap-[5px] items-center w-[175px] text-[12px] overflow-hidden bg-[#201818] rounded-[8px] px-[15px] text-[#A93434]">
              <div className="12px pr-[5px]">
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="5.5" cy="5.5" r="5.5" fill="#A93434" />
                  <path d="M3 3L5.5 5.5M5.5 5.5L8 3M5.5 5.5L3 8M5.5 5.5L8 8" stroke="black" />
                </svg>
              </div>
              {error}
            </div>
          ) : null}

          {!submitting ? (
            <GrayButton
              height="37px"
              onClick={async () => {
                try {
                  setSubmitting(true);
                  await onSubmit(hashrate);
                } catch (e) {
                  setSubmitting(false);
                  if (e instanceof ValidationError) {
                    setInvalid(true);
                    setError('Заполните поле ввода');
                  }
                  if (e instanceof ServerError) {
                    setInvalid(true);
                    setError(e.error);
                  }
                }
              }}
              title="Сохранить изменения"
            />
          ) : (
            <Loader size={30} loading={true} />
          )}
        </div>
        <div className="cursor-pointer text-[10px] mb-[20px]" onClick={onClose}>
          Отменить
        </div>
      </div>
    </Popup>
  );
};
